import { z } from "zod";
export var RoomTypeEnum;
(function (RoomTypeEnum) {
    RoomTypeEnum["DocumentationPageOld"] = "documentation-page";
    RoomTypeEnum["DocumentationPage"] = "doc-page";
    RoomTypeEnum["DesignSystemVersion"] = "design-system-version";
    RoomTypeEnum["Workspace"] = "workspace";
    RoomTypeEnum["ForgeProject"] = "forge-project";
    RoomTypeEnum["ForgeProjectArtifact"] = "forge-project-artifact";
    RoomTypeEnum["ForgeProjectFeature"] = "forge-project-feature";
})(RoomTypeEnum || (RoomTypeEnum = {}));
export const RoomTypeSchema = z.nativeEnum(RoomTypeEnum);
export const RoomType = RoomTypeSchema.enum;
